<nav class="c--breadcrumb" role="navigation" [attr.aria-label]="'navigation.breadcrumb.a11y.title' | translate">
  @if (isDevice$) {

    @if (breadcrumb.length > 1) {
      <ol sd-list-inline class="is-xs"  data-testid="is-device-list">
        <li class="c__back"  data-testid="is-device-item">
          <sd-link [link]="backHomeMobile ? breadcrumb[0] : breadcrumb[breadcrumb.length - 2]">
            <sd-icon [brand]="brand" name="icon-arrow-left" [size]="iconSize.xs" aria-hidden="true" />
            <span class="is-caption is-bold">
              {{ backHomeMobile ? ('navigation.breadcrumb.home' | translate) : (breadcrumb[breadcrumb.length - 2].linkName) }}
            </span>
          </sd-link>
        </li>
      </ol>
    } @else {
      <strong aria-current="page" class="is-caption" data-testid="one-item-breadcrumb">
        {{ breadcrumb[0].linkName }}
      </strong>
    }

  } @else {

    <ol sd-list-inline class="is-xs" data-testid="is-not-device-list">
      @for (item of breadcrumb; track item.linkName) {
        <li data-testid="is-device-item">
          @if (!$last) {
            @if (item.url) {
              <a [routerLink]="item.url" class="is-bold is-caption" (click)="onClickLink(item)" data-testid="item-url">
                {{ item.linkName }}
              </a>
            } @else {
              <span class="is-bold is-caption">{{ item.linkName }}</span>
            }
            <sd-icon class="is-separator" [brand]="brand" [name]="separator" [size]="iconSize.xs" aria-hidden="true"  data-testid="separator"/>
          } @else {
            <span aria-current="page" class="is-caption" data-testid="last-element">{{ item.linkName }}</span>
          }
        </li>
      }
    </ol>

  }
</nav>
